import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import moment from "jalali-moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ScatterPlotChart = ({ serverData, chartType, startDate, endDate }) => {

  const PotentielSowingDate = serverData?.sowingDateRecommendation?.sowingDateRangeForecasts?.map(
    (potentiel) => parseInt(potentiel.performancePotential)
  );

  const irrigationEfficiencyPercentage = serverData?.sowingDateRecommendation?.sowingDateRangeForecasts?.map(
    (irrigationPercentage) => parseInt(irrigationPercentage.irrigationEfficiencyPercentage)
  );

  const currentGeorgianYear = moment().year();

  const labels = serverData?.sowingDateRecommendation?.sowingDateRangeForecasts?.map(
    (sowingDayOfYear) => {
      return moment(`${currentGeorgianYear}-01-01`, "YYYY-MM-DD")
        .add(sowingDayOfYear.sowingDayOfYear, "days")
        .toDate()
        .toLocaleDateString("fa-IR");
    }
  );


  // تعیین داده‌ها و تنظیمات محور Y بر اساس نوع نمودار
  const data =
    chartType === "potential"
      ? {
          labels,
          datasets: [
            {
              label: "پتانسیل عملکرد",
              data: PotentielSowingDate,
              borderColor: "#491086",
              tension: 0.5,
              fill: false,
              pointRadius: 0, // حذف نقاط
              datalabels: {
                display: false,
              },
            },
            
          ],
        }
      : {
          labels,
          datasets: [
            {
              label: "راندمان آبیاری",
              data: irrigationEfficiencyPercentage,
              borderColor: "#1E90FF",
              tension: 0.5,
              fill: false,
              pointRadius: 0, // حذف نقاط
              datalabels: {
                display: false,
              },
            },
          ],
        };

  const yLabel =
    chartType === "potential"
      ? "پتانسیل عملکرد (کیلوگرم در هکتار)"
      : "بهره‌وری آبیاری (درصد)"

  const options = {
    scales: {
      x: {
        ticks: {
          font: {
            family: "B-NAZANIN",
            size: 13,
            weight: "bold",
          },
        },
      },
      y: {
        title: {
          display: true,
          text: yLabel,
          font: {
            family: "B-NAZANIN",
            size: 14,
            weight: "bold",
          },
        },
        ticks: {
          font: {
            family: "B-NAZANIN",
            size: 14,
            weight: "bold",
          },
        },
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "top",
         labels: {
          font: {
            family: 'B-Nazanin', // نام فونت دلخواه
            size: 14, // اندازه فونت
            weight: 'bold', // پررنگ کردن فونت
          },
        },
      },
      title: {
        display: true,
        text:
          chartType === "potential"
            ? "بهترین تاریخ کاشت بر اساس پتانسیل عملکرد"
            : "بهره‌وری آبیاری با توجه به تاریخ کاشت",
        font: {
          family: "B-NAZANIN",
          size: 14,
          style: "normal",
          weight: "bold",
        },
      },
      annotation: chartType === "potential" ? {
        annotations: {
          box1: {
            type: 'box',
            xMin: startDate, // تاریخ شروع هایلایت
            xMax: endDate, // تاریخ پایان هایلایت
            backgroundColor: 'rgba(148, 0, 211, 0.2)', // رنگ ناحیه هایلایت
            borderColor: 'rgba(148, 0, 211, 0.6)',
            borderWidth: 2,
            borderRadius: 5
          }
        }
      } : {}
    },
  };

  return (
    <div className="flex justify-center w-[700px] h-[340px] !font-[B-Nazanin]">
      <Line className="!font-[B-Nazanin]" options={options} data={data} />
    </div>
  );
};

export default ScatterPlotChart;
